// =====================================================================
// Yapısal veri (JSON-LD) — Seo.jsx'e `jsonLd` prop'u olarak geçirin.
// Google zengin sonuç (rich result) uygunluğu için.
// =====================================================================

// 1) Organization / SoftwareApplication — Ana sayfada (/) kullanın
export const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Tilki Otomasyon',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  url: 'https://tilkiotomasyon.com/',
  description:
    'Restoran, kafe, bar ve pub işletmeleri için QR menü, sipariş, sadakat ve raporlama modüllerini tek panelde birleştiren otomasyon platformu.',
  offers: {
    '@type': 'Offer',
    price: '1200',
    priceCurrency: 'TRY',
    description: 'Aylık plan',
  },
  publisher: {
    '@type': 'Organization',
    name: 'Tilki Otomasyon',
    telephone: '+90-542-254-55-35',
    email: 'iletisim@tilkiotomasyon.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'İstanbul',
      addressCountry: 'TR',
    },
  },
};

// 2) FAQPage — Fiyatlar (/fiyatlar) sayfasındaki SSS bölümü için.
//    Sorular sayfadaki metinle birebir aynı olmalı.
export const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Aylık abonelikten yıllık aboneliğe nasıl geçerim?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Aylık abonelikten yıllık aboneliğe geçmek için sadece bizimle iletişime geçmeniz yeterli. Son ödeme tarihiniz geçtikten sonra paketiniz yıllık aboneliğe çevrilecektir ve yıllık abonelik kampanyalarından faydalanabileceksiniz.',
      },
    },
    {
      '@type': 'Question',
      name: 'Yeni gelen geliştirmeler için ek ücret talep edilir mi?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Hayır. Halihazırda bulunan paketler üzerinden fiyatlandırma politikası izlenmektedir. Tüm güncellemeler ve yeni özellikler abonelik ücretine dahildir.',
      },
    },
    {
      '@type': 'Question',
      name: 'Sistemde yıllık bakım ücreti var mı?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Hayır. Abonelik üzerine kurulu bir sistem olduğundan bakım ücreti bulunmamaktadır. Tüm bakım ve güncellemeler abonelik ücretine dahildir.',
      },
    },
  ],
};

// 3) BreadcrumbList örneği (opsiyonel, alt sayfalarda)
export const breadcrumb = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.name,
    item: `https://tilkiotomasyon.com${it.path}`,
  })),
});
